<template>
    <div>
        <div class="form-group row pt-3">
            <div class="w-100 " @click.prevent="toggleExpanded">
                <label class="disable-select search-collapse__label">
                    <span class="caret" :class="{ 'caret-expanded': isExpanded }">
                        <i class="fas fa-caret-right"></i>
                    </span>
                    {{ title }}</label>
            </div>
        </div>
        <Transition name="slide-fade">
            <div v-if="isExpanded">
                <slot>
                </slot>
            </div>
        </Transition>
    </div>
</template>
<script>
export default {
  name: 'SearchCollapse',
  props: {
    expanded: {
      type: Boolean,
      required: false,
      default: false
    },
    title: {
      type: String,
      required: true,
      default: null
    }
  },
  data () {
    return {
      isExpanded: this.expanded
    }
  },
  methods: {
    toggleExpanded () {
      this.isExpanded = !this.isExpanded
    }
  }
}
</script>
<style lang="scss">
.disable-select {
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}

.search-collapse__label {
    font-size: medium;
    font-weight: 600;
    letter-spacing: 0.3px;
    color: #2e6e60;
    cursor: pointer;
    margin-bottom: 0;
}

.caret {
    display: inline-block;
    margin-right: .25rem;
    transition: transform 0.3s ease-in-out;
}

.caret-expanded {
    transition: transform 0.15s ease-in-out;
    transform: rotate(90deg);
}

.slide-fade-enter-active {
    transition: all 0.3s ease-out;
}

.slide-fade-leave-active {
    transition: all 0.25s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
    transform: translateY(-20px);
    opacity: 0;
}

#sidebar-1 {
    .formulate-input {
        margin-bottom: .5rem;
        input {
            background-color: #fff;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/containers/layout/sidebars/components/SearchCollapse.vue